import React from "react";
import DataDevis from "../dataDevis";
class FrontEcheancier extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const {devis,focusError,showValidate} = this.props.container
        const params = devis.params
        const now = new Date()
        let year = now.getFullYear()
        let month = now.getMonth()
        const incMonth = () => {
            month += 1
            if ( month >= 12 ) {
                year += 1
                month = 0
            }
        }
        const monthToDisplay = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Sept.','Oct.','Nov.','Déc.']

        let cells1 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            cells1.push(<th key={i}>{monthToDisplay[month]}<br/>{year}<br/><span>TTC</span></th>)
            incMonth()
        }

        let cells2 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            cells2.push(<th key={i}>{monthToDisplay[month]}<br/>{year}<br/><span>TTC</span></th>)
            incMonth()
        }

        const prices = this.getPrices()

        let tcells1 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            tcells1.push(<td key={i} className={(i%2)?'odd':'even'}>{DataDevis.fancyPrice(prices[i],'','0')} €</td>)
        }
        let tcells2 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            tcells2.push(<td key={i} className={(i%2)?'odd':'even'}>{DataDevis.fancyPrice(prices[i+6],'','0')} €</td>)
        }

        return <div className={this.props.hidden ? 'collapsable hidden' : 'collapsable'}>
                <table className="echeancier">
                <tbody>
                    <tr>{cells1}</tr>
                    <tr>{tcells1}</tr>
                    <tr>{cells2}</tr>
                    <tr>{tcells2}</tr>
                </tbody>
            </table>
        </div>
    }
}

export class FrontEcheancierXena extends FrontEcheancier {

    getPrices() {
        const {devis} = this.props.container
        const {params} = devis
        const normalMonth = (params.periodicite=='M')?devis.toPayMonthly(params.formule):0
        return [
            devis.toPay(),
            0,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth
        ]
    }
}


export class FrontEcheancierAxa extends FrontEcheancier {

    getPrices() {
        const {devis} = this.props.container
        const axa = devis.getAxa()
        const {params} = devis
        const firstPrelevement = axa.monthFirstPrelevement()
        const normalMonth = (params.periodicite=='M')?axa.echeanceOptionsSansFrais(false,'monthly'):0
        const halfMonth = ( new Date().getDate() > 15 )
        return [
            parseFloat(axa.frais) + ( halfMonth ? 0 : axa.perception() ),
            (halfMonth ? axa.perception() : 0)+(( firstPrelevement<=1 )?normalMonth:0),
            ( firstPrelevement<=2 )?normalMonth:0,
            ( firstPrelevement<=3 )?normalMonth:0,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth
        ]
    }
}


export class FrontEcheancierFma extends FrontEcheancier {

    getPrices() {
        const {devis} = this.props.container
        const fma = devis.getFma().setChoicesFromDevis()
        const {params} = devis
        const normalMonth = (params.periodicite=='M')?fma.mensuel():0

        return [
            (params.periodicite=='M') ? fma.fraisCB()+fma.comptantMensuel() : fma.coutTotal(),
            0,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth,
            normalMonth
        ]
    }
}